import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import { Button } from "@src/appV2/redesign/components/Button";
import { DocumentStatusPill } from "@src/appV2/redesign/Documents/components/StatusPill";
import { DOCUMENT_DETAILS_FULL_PATH } from "@src/appV2/redesign/Documents/paths";
import { generatePath, useHistory } from "react-router-dom";

import { type MissingRequirement } from "../../types";
import { VisitBottomSheetInnerCard } from "./BaseInnerCard";

interface MissingDocumentsInnerCardProps {
  missingRequirements: MissingRequirement[];
}

export function MissingDocumentsInnerCards(props: MissingDocumentsInnerCardProps) {
  const { missingRequirements } = props;
  const history = useHistory();

  return (
    <>
      {missingRequirements.map((requirement) => {
        if (!requirement.visibleToHCP) {
          return (
            <VisitBottomSheetInnerCard
              key={requirement.reqId}
              pill={<DocumentStatusPill variant="in_review" size="medium" />}
              illustrationType="document-review"
              title={requirement.name}
              description="We're processing this document on your behalf."
              footer={
                <Button
                  fullWidth
                  onClick={async () => {
                    await openZendeskMessaging();
                  }}
                >
                  Contact Support
                </Button>
              }
            />
          );
        }

        return (
          <VisitBottomSheetInnerCard
            key={requirement.reqId}
            illustrationType="document-upload"
            title={requirement.name}
            description="Please upload this document before booking this visit."
            footer={
              <Button
                fullWidth
                onClick={() => {
                  history.push(
                    generatePath(DOCUMENT_DETAILS_FULL_PATH, {
                      requirementId: requirement.reqId,
                    })
                  );
                }}
              >
                Upload
              </Button>
            }
          />
        );
      })}
    </>
  );
}
